import React from "react";
import "./styles/CardDisplayCard.css";

const CardDisplayCard = ({
    title = "Seamless Spending with Global Acceptance",
    description = "The MAPex Card is accepted anywhere major cards are supported, including online platforms, retail stores, and ATMs worldwide.",
    bulletPoints = [
        "Why It Matters? Use your earnings effortlessly for everyday purchases, travel, or subscriptions without worrying about currency conversions or compatibility.",
    ],
    icon,
    className = "",
}) => {
    console.log(icon, "icon");
    return (
        <div className={`card-display-card ${className}`}>
            <div className="card-content">
                <h2 className="card-title">{title}</h2>

                <p className="card-description">{description}</p>

                {bulletPoints && bulletPoints.length > 0 && (
                    <ul className="card-bullet-points">
                        {bulletPoints.map((point, index) => (
                            <li key={index} className="bullet-point">
                                {point}
                            </li>
                        ))}
                    </ul>
                )}

                {icon && (
                    <div className="card-icon">
                        <img src={icon} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CardDisplayCard;
